export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/uploadDocs.f4856265.svg","height":47,"width":46,"blurWidth":0,"blurHeight":0};